import {
	type AuthRepository,
	type TokenPair,
	type TwoFactorMethodType,
	TwoFactorMethodTypeOptions
} from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { booleanValueObject, enumValueObject, stringValueObject } from '@contexts/shared/domain';

export type TwoFALoginInput = {
	token: string;
	code: string;
	methodType: TwoFactorMethodType;
	rememberMe: boolean;
};

export type TwoFALoginUseCase = UseCase<TwoFALoginInput, TokenPair>;

export function twoFAloginBuilder(authRepository: AuthRepository): TwoFALoginUseCase {
	return async function twoFAlogin(input: TwoFALoginInput): Promise<TokenPair> {
		const token = stringValueObject().validate('token', input.token);
		const code = stringValueObject().validate('code', input.code);
		const methodType = enumValueObject<TwoFactorMethodTypeOptions, TwoFactorMethodType>()
			.setEnum(TwoFactorMethodTypeOptions)
			.validate('methodType', input.methodType);

		const rememberMe = booleanValueObject().validate('rememberMe', input.rememberMe);

		return authRepository.twoFactorLogin(token, code, methodType, rememberMe);
	};
}
